import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const root = css`
  position: relative;
  max-inline-size: ${spacing(375 / 8)};
`

export const closeButton = css`
  position: absolute;
  inset-block-start: ${spacing(2.375)};
  inset-inline-end: ${spacing(1.375)};
  && {
    background: transparent; // нестандартная кнопка закрытия, поэтому нужно перебивать стили
  }
`
